(function(){
    angular.module('tmx-app').factory('AuditlogService', ['tmxResource', function(tmxResource){
    
        var log = tmxResource("AuditLog");
    
      
        log.gridColumn = [
            {
                hidden: true,
                field: "LogId",
                title: "Log ID",
                type: "numeric",
                search:false,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('LogId')}\" >{{'LogId' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"LogId\")' ></i></span>"
        
            }, 
            {
                field: "TimeStamp",
                title: "TimeStamp",
                type: "text",
                search:false,
                template: "{{dataItem.TimeStamp}}",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('TimeStamp')}\" >{{'TimeStamp' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"TimeStamp\")' ></i></span>"
     
            }, 

            {
                field: "UserName",
                title: "User Name",
                type: "text",
                search:true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('UserName')}\" >{{'UserName' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"UserName\")' ></i></span>"
       
            },
            {
                field: "Role",
                title: "Role",
                type: "text",
                search:true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('Role')}\" >{{'Role' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"Role\")' ></i></span>"
        
            },
            {
                field: "ActivityType",
                title: "Activity Type",
                type: "text",
                search:true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('ActivityType')}\" >{{'ActivityType' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"ActivityType\")' ></i></span>"
       
            },
            {
                field: "Activity",
                title: "Activity",
                type: "text",
                search:true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('Activity')}\" >{{'Activity' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"Activity\")' ></i></span>"
       
            },
            {
                field: "Action",
                title: "Action",
                type: "text",
                search:false,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('Action')}\" >{{'Action' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"Action\")' ></i></span>"
       
            },
            {
                field: "Method",
                title: "Method",
                type: "text",
                search:false,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : AuditlogCtrl.isFiltered('Method')}\" >{{'Method' | translate}}<i class='fa fa-filter' ng-if='AuditlogCtrl.isFiltered(\"Method\")' ></i></span>"
       
            }
       

        ];
    
        log.columns = angular.copy(log.gridColumn);
    
        return log;
    
    // }]);
    }])
})();